import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

/**
 * @description 平台信息
 * @type {Array}
 */
export const PLAYFORM = [
  {
    label: '哔哩哔哩',
    qrcode: require('@src/business-components/modals/images/qrcode-bilibili.png'),
    link: 'https://space.bilibili.com/3493282537540091?spm_id_from=333.1007.0.0',
    linkText: '进入B站',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '公众号',
    qrcode: require('@src/business-components/modals/images/qrcode-gzh.png'),
    link: '',
    linkText: '扫码关注',
    linkTheme: 'dark',
    clickable: false
  },
  {
    label: 'QQ号',
    qrcode: require('@src/business-components/modals/images/qrcode-gzh.png'),
    link: '',
    linkText: '扫码关注',
    linkTheme: 'dark',
    clickable: false
  },
  {
    label: '抖音',
    qrcode: require('@src/business-components/modals/images/qrcode-douyin.png'),
    link: 'https://www.douyin.com/user/MS4wLjABAAAA91Y1f9H4q0ImiT7d4f4KpY9SSiOLWZjjcxzB1jMpaZAdfvZgu5VcPsbWntIq6Qs3?from_tab_name=main',
    linkText: '进入抖音',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '小红书',
    qrcode: require('@src/business-components/modals/images/qrcode-xhs.png'),
    link: 'https://www.xiaohongshu.com/user/profile/67526aaf000000001d02cc5d?xsec_token=AB7tgXqhObA3WGPvojS-bbuJXbUKneJFN4ucrFOmqkNJ0=&xsec_source=pc_search',
    linkText: '进入小红书',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '分享',
    qrcode: require('@src/business-components/modals/images/qrcode-xhs.png'),
    link: 'https://www.xiaohongshu.com/user/profile/67526aaf000000001d02cc5d?xsec_token=AB7tgXqhObA3WGPvojS-bbuJXbUKneJFN4ucrFOmqkNJ0=&xsec_source=pc_search',
    linkText: '复制链接',
    linkTheme: 'light',
    clickable: true
  }
];

// 世界观主页链接
export const WORLD_VIEW_LINK = `https://${
  IS_MASTER_ENV ? '' : 'test-zt.seasungames.com/'
}mechabreak.seasungames.com/p/m/2026/01/27/world-view/${lang}/index.html`;
// 世界观详情页链接
export const WORLD_VIEW_DETAIL_LINK = `https://${
  IS_MASTER_ENV ? '' : 'test-zt.seasungames.com/'
}mechabreak.seasungames.com/p/m/2026/01/27/world-view/${lang}/index.html#/wordView`;
